import React, { ReactElement, ReactNode } from 'react';

import useFaultsHook, { FaultsHistoryHook } from 'features/faults-history/context/faults-history-hook';

const FaultsContext = React.createContext<FaultsHistoryHook>({} as never);

interface IProps {
  children: ReactNode;
}

export const FaultsHistoryProvider = (props: Readonly<IProps>): ReactElement => (
  <FaultsContext.Provider value={useFaultsHook()}>{props.children}</FaultsContext.Provider>
);

export const useFaultsHistoryContextProvider = (): FaultsHistoryHook => React.useContext<FaultsHistoryHook>(FaultsContext);
